import formInputsTypes from '../simulatorConstant';
import forfaits from './data';


const ForfaitsSM = {
	id: 'ForfaitsSM',
	type: formInputsTypes?.CHECKBOX_INPUT,
	label: 'Forfaits',
	name: 'ForfaitsSM',
	className: 'col-12',
	classGroup: 'simulator-check',
	// nextStepData: data,
	nextStepData: false,
	nextStep: false,
	options: forfaits,
};

export default ForfaitsSM;
